import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "src/store";
import { API_PROD_URL } from "src/utils/axios";

const interactiveReportBaseUrl =
  "https://report-automation-dev.orangefield-fc298ced.centralus.azurecontainerapps.io";
// API_PROD_URL

export const interactiveReportInput = createAsyncThunk(
  "interactive-report-input",
  async (
    {
      template_json,
      userId,
      threadId,
      use_case,
      user_files
    }: {
      template_json: string;
      userId: string;
      threadId: string;
      use_case: string,
      user_files: File[]
    },
    { getState },
  ): Promise<any> => {
    const state = getState() as RootState;
    // Temp Logic for fetching file from url

    const formdata = new FormData();

    formdata.append("company", state.auth?.user?.company_name || "AI");
    formdata.append("region", "North America");
    formdata.append("industry", "AI");
    formdata.append("use_case", use_case);
    formdata.append("template_json", template_json);
    user_files.forEach((file) => {
      formdata.append(`user_files`, file);
    });

    const response: any = await axios.post(
      `${interactiveReportBaseUrl}/input?user_id=${userId}&thread_id=${threadId}`,
      formdata,
      {
        headers: { "Content-Type": "application/json", "ngrok-skip-browser-warning": "true" },
      },
    );
    return response;
  },
);

export const getSourceInsights = createAsyncThunk(
  "interactive-report-source-insights",
  async ({
    userId,
    threadId,
  }: {
    userId: string;
    threadId: string;
  },): Promise<any> => {
    const response: any = await axios.get(`${interactiveReportBaseUrl}/sources?userId=${userId}&threadId=${threadId}`, {
      headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
    });
    return response;
  },
);

export const getOnePagerExecutiveSummary = createAsyncThunk(
  "get-executive-summary",
  async ({
    userId,
    threadId,
  }: {
    userId: string;
    threadId: string;
  },): Promise<any> => {

    const response: any = await axios.post(`${interactiveReportBaseUrl}/one_pager?userId=${userId}&threadId=${threadId}`, {
      headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
    });
    return response;
  },
);

export const getPipelineStatus = createAsyncThunk(
  "interactive-report-pipeline-status",
  async ({ userId, threadId }: { userId: string; threadId: string }): Promise<any> => {
    const response: any = await axios.get(
      `${interactiveReportBaseUrl}/check_pipeline_status?userId=${userId}&threadId=${threadId}`,
      {
        headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
      },
    );
    return response;
  },
);

export const getInteractiveReportAction = createAsyncThunk(
  "interactive-report-get-report",
  async ({ userId, threadId }: { userId: string; threadId: string }): Promise<any> => {
    const promiseResponse = await Promise.all([
      await axios.get(
        `${interactiveReportBaseUrl}/statistics_analysis?userId=${userId}&threadId=${threadId}`,
        {
          headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
        },
      ),
      await axios.get(`${interactiveReportBaseUrl}/get_visual_maps?userId=${userId}&threadId=${threadId}`, {
        headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
      }),
    ]);

    return promiseResponse;
  },
);

export const getReportTitle = createAsyncThunk(
  "interactive-report-get-title",
  async ({ userId, threadId }: { userId: string; threadId: string }): Promise<any> => {
    const promiseResponse =
      await axios.post(
        `${API_PROD_URL}/report_title/?user_id=${userId}&thread_id=${threadId}`,
        {},
        {
          headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
        },
      );
    return promiseResponse;
  },
);

export const executePipelineAction = createAsyncThunk(
  "interactive-report-execute-pipeline",
  async ({ userId, threadId }: { userId: string; threadId: string }): Promise<any> => {
    const response: any = await axios.post(
      `${interactiveReportBaseUrl}/execute_pipeline`,
      {
        userId: userId,
        threadId: threadId,
      },
      {
        headers: { accept: "application/json", "ngrok-skip-browser-warning": "true" },
      },
    );
    return response;
  },
);
